/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Key type to disable.
 */
export const KeyType = {
  Chat: "chat",
  Internal: "internal",
} as const;
/**
 * Key type to disable.
 */
export type KeyType = ClosedEnum<typeof KeyType>;

export type DisableOpenRouterKeyRequestBody = {
  /**
   * Key type to disable.
   */
  keyType: KeyType;
  /**
   * Organization that owns the key.
   */
  organizationId: string;
};

/** @internal */
export const KeyType$outboundSchema: z.ZodMiniEnum<typeof KeyType> = z.enum(
  KeyType,
);

/** @internal */
export type DisableOpenRouterKeyRequestBody$Outbound = {
  key_type: string;
  organization_id: string;
};

/** @internal */
export const DisableOpenRouterKeyRequestBody$outboundSchema: z.ZodMiniType<
  DisableOpenRouterKeyRequestBody$Outbound,
  DisableOpenRouterKeyRequestBody
> = z.pipe(
  z.object({
    keyType: KeyType$outboundSchema,
    organizationId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      keyType: "key_type",
      organizationId: "organization_id",
    });
  }),
);

export function disableOpenRouterKeyRequestBodyToJSON(
  disableOpenRouterKeyRequestBody: DisableOpenRouterKeyRequestBody,
): string {
  return JSON.stringify(
    DisableOpenRouterKeyRequestBody$outboundSchema.parse(
      disableOpenRouterKeyRequestBody,
    ),
  );
}
